import React, { useCallback, useEffect, useState } from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { Option } from '../../types/option'

import { OtherOptionInput } from '../OtherOptionInput'

import { CheckBox } from 'components'

import * as S from './styles'
import { Controller, useFormContext } from 'react-hook-form'
import { MedicalRecordFormData } from '../../medicalRecordSchema'

const checkBoxOptions: Option[] = [
  { id: 'patient-consumption-alcohol', name: 'Álcool' },
  { id: 'patient-consumption-tobacco', name: 'Tabaco' },
  { id: 'patient-consumption-drugs', name: 'Drogas' },
  { id: 'patient-consumption-others', name: 'Outros' },
]

const PATIENT_CONSUMPTION_INPUT_NAME = 'patient_consumptions'

export function PatientConsumption(): JSX.Element {
  const { setValue, control, getValues } = useFormContext<MedicalRecordFormData>()

  const [selectedOptions, setSelectedOptions] = useState<Option[]>([])

  const patientConsumptionsDefault: string[] = getValues('patient_consumptions') || []

  const hasOtherOptionInSelectedOptions = selectedOptions.some(
    (option) => option.id === 'patient-consumption-others'
  )

  const handleToggleSelectOption = useCallback((checkBoxOption: Option) => {
    setSelectedOptions((prevSelectedOptions) => {
      const isInSelectedOptions = prevSelectedOptions.some(
        (option) => option.id === checkBoxOption.id
      )

      if (isInSelectedOptions) {
        const newOptions = prevSelectedOptions.filter(
          (option) => option.id !== checkBoxOption.id
        )

        if (checkBoxOption.id === 'patient-consumption-others') {
          setValue('other_patient_consumption', undefined)
        }

        setValue(
          PATIENT_CONSUMPTION_INPUT_NAME,
          newOptions.map((option) => option.id as string)
        )
        return newOptions
      } else {
        const newOptions = [...prevSelectedOptions, checkBoxOption]
        setValue(
          PATIENT_CONSUMPTION_INPUT_NAME,
          newOptions.map((option) => option.id as string)
        )
        return newOptions
      }
    })
  }, [])

  useEffect(() => {
    setSelectedOptions(patientConsumptionsDefault?.map((patientConsumptionDefault) => ({ id: patientConsumptionDefault, name: '' })))
  }, [])

  return (
    <S.PatientConsumptionContainer>
      <Typography weight='bolder' variant='content2'>
        O paciente consome...
      </Typography>

      <S.CheckBoxOptions>
        {checkBoxOptions.map((option) => {
          const isSelected = selectedOptions.findIndex((selectedOption) => selectedOption.id === option.id) >= 0

          return (
            <CheckBox
              key={option.id}
              indeterminate={false}
              customBorderColor={isSelected ? null : '#4b4b4b'}
              isSelected={Boolean(isSelected)}
              onClickCheckBox={() => handleToggleSelectOption(option)}
              title={option.name}
            />
          )
        })}
      </S.CheckBoxOptions>

      {hasOtherOptionInSelectedOptions && (
        <Controller
          control={control}
          name='other_patient_consumption'
          render={({ field, fieldState: { error } }) => (
            <OtherOptionInput
              {...field}
              errorMessage={error?.message}
              placeholder='Descreva'
            />
          )}
        />
      )}
    </S.PatientConsumptionContainer>
  )
}
